import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=e765745a&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e765745a')) {
      api.createRecord('e765745a', component.options)
    } else {
      api.reload('e765745a', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=e765745a&", function () {
      api.rerender('e765745a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4C2EbMGq4iy33/JS/imageCarousel.vue"
export default component.exports